
import { defineComponent, reactive, computed } from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarCategoriaPlanoConta from '@/components/Cadastros/PlanosContas/SelecionarCategoriaPlanoConta.vue';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarConta from '@/components/Cadastros/Financeiro/SelecionarConta.vue';
import { IPedidoCompraDetalhePagamento } from '@/models/Entidades/Compras/IPedidoCompra';

export default defineComponent({
  name: 'PedidoCompraDetalhePagamentoOutros',
  props: {
    editavel: {
      type: Boolean,
      required: true,
    },
    empresa: {
      type: Number,
      required: true,
    },
    detalhePagamento: {
      type: Object as () => IPedidoCompraDetalhePagamento,
      required: true,
    },
  },
  components: {
    Card,
    SelecionarData,
    CampoNumerico,
    SelecionarConta,
    SelecionarCategoriaPlanoConta,
  },
  emits: ['update:detalhePagamento', 'alterarTipoDocumento', 'atualizarValorTotal'],
  setup(props, { emit }) {
    const servicoNotaFiscal = new ServicoNotaFiscal();
    servicoNotaFiscal.requisicaoSistema();
    const { telaBase } = useTelaBase();

    const state = reactive({});

    const computedDetalhePagamento = computed({
      get: () => props.detalhePagamento,
      set: (val: IPedidoCompraDetalhePagamento) => {
        emit('update:detalhePagamento', val);
      },
    });

    function alterarTipoDocumento() {
      emit('alterarTipoDocumento');
    }

    return {
      props,
      state,
      telaBase,
      UtilitarioGeral,
      computedDetalhePagamento,
      alterarTipoDocumento,
    };
  },
});
